import {
  RFQ_LIST,
  RFQ_LIST_SUCCESS,
  SELECT_CHANGEVALUE,
  RFQ_ROW_DATA,
  RFQ_ROW_DATA_SUCCESS,
  QUOTATION_ROW_DATA,
  QUOTATION_ROW_DATA_SUCCESS,
  QUOTATION_CHECKED,
  APPROVED_QUANTITY,
  RESET_CELL_UPDATE,
  COMPARE_QUOTATION_ADD,
  COMPARE_QOUTATION_DATA,
  COMPARE_QOUTATION_DATA_SUCCESS,
  COMPARE_QOUTATION_LIST,
  COMPARE_QOUTATION_LIST_SUCCESS,
  SET_PARAMS,
  FILTER_INPUT_CHANGEVALUE,
  FILTER_SELECT_CHANGEVALUE,
  GENERATE_PURCHASE_ORDER,
  GENERATE_PURCHASE_ORDER_RESPONSE,
  PURCHASE_ORDER_LIST,
  PURCHASE_ORDER_LIST_SUCCESS,
  PURCHASE_ORDER_DATA,
  TOGGLE_ITEM_MENU,
  LIST_LAYOUT,
  FILTERS_SHOW_RIGHT_SIDEBAR,
  FILTERS_HIDE_RIGHT_SIDEBAR,
  CLEAR_FILTER,
  PO_MODEL_CLOSE,
  PO_MODEL_OPEN,
  PO_VEND_DATA,
  INPUT_CHANGEVALUE,
  PO_SELECT_CHANGEVALUE,
  RESET_SUBLOCATION,
} from "./actionTypes";

const initialState = {
  rfqList: [],
  CQData: {},
  RFQrowdata: [],
  Quotations: [],
  CQVendorTotals: {},
  RFQCellData: [],
  CQbodyData: [],
  CQBodyTCData: [],
  CQRowData: {},
  CQRowList: [],
  CQPOList: [],
  POData: [],
  loading: false,

  HideSubmiteData: false,
  newclm: "",
  newrow: -1,
  CQRowListCount: 0,
  Sortvar: {
    code: "QUOTATION NO",
    createdon: "CREATED ON",
  },
  params: {
    no_of_pages: 0,
    page_size: 10,
    page: 1,
    search: "",
    currentSort: "code",
    sortOrder: "-",
  },
  layout: "list",

  showFilterRightSidebar: false,
  PO_Model: false,
  PO_ID: null,

  PORowData: {},
  PO_index: null,
  sublocationslist2: { results: [] },
};

const CompareQuotation = (state = initialState, action) => {
  switch (action.type) {
    case RFQ_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case RFQ_LIST_SUCCESS:
      state = {
        ...state,
        rfqList: action.payload,
        loading: false,
      };
      break;
    case SELECT_CHANGEVALUE:
      state = {
        ...state,
        CQData: {
          ...state.QRowData,
          [action.payload.key]: action.payload.label,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case RFQ_ROW_DATA:
      state = {
        ...state,
        loading: true,
      };
      break;
    case RFQ_ROW_DATA_SUCCESS:
     
      state.RFQCellData = [
        { vendId: 0, CellName: "ItemName", headerName: "Item Name" },
      ];

      var rfqvendors = action.payload.rfqvendors.sort(function (a, b) {
        return b.loginstatus - a.loginstatus;
      });

      rfqvendors.map((vend, i) => {
        var Hcelldata = {
          CellName: "Vendor" + vend.vendor.id,
          headerName: vend.vendor.name,
          vendId: vend.vendor.id,
        };
        state.RFQCellData.push(Hcelldata);
        return 0;
      });

      state.CQbodyData = action.payload.rfqitems.map((item) => {
       
        return {
          ItemName: {
            rfqItemId: item.id,
            product_id: item.product.id,
            Name: item.product.name,
            Quantity: item.qty,
            balance_qty: item.balance_qty,
            Quantity_unit: {
              units: item.unit.units,
              name: item.unit.name,
            },
            make: item.make,
            description: item.description,
            totalqty: 0,
            totalpoqty: 0,

           	orderlocation: item.orderlocation
								? { ...item.orderlocation }
								: (item.orderlocations?.[0] ? { ...item.orderlocations[0] } : null),
            qualities: item.qualities || [],
          },
        };
      });

      state = {
        ...state,
        RFQrowdata: action.payload,
      };
      break;
    case QUOTATION_ROW_DATA:
      state = {
        ...state,
      };
      break;
    case QUOTATION_ROW_DATA_SUCCESS:
      
      
      try {
        state.Quotations = action.payload;
        state.CQVendorTotals = {};

        action.payload.forEach((q) => {
          if (q.vendor?.id) {
            state.CQVendorTotals[q.vendor.id] = {
              total: Number(q.total) || 0,
              gst: Number(q.gst) || 0,
              grand_total: Number(q.grand_total) || 0,
            };
          }
        });
        
        var rfqItemIds = state.CQbodyData.map((item) => {
          return item.ItemName.rfqItemId;
        });
        
        state.CQBodyTCData = [
          { ItemName: "Terms & Conditions" },
          { ItemName: "Other Details" },
        ];
        
        action.payload.forEach((q, key) => {
          q.qitems.forEach((item, j) => {
           
            var i = rfqItemIds.indexOf(item.rfqitem);

            state.CQbodyData[i]["Vendor" + q.vendor.id] = {
              Quantity: item.originalqty,
              balance_qty: state.CQbodyData[i].ItemName.balance_qty,
              unit: item.unit ? { id: item.unit.id, name: item.unit.name } : { id: null, name: "" },
              baseprice: item.baseprice,
              discount: item.discount,
              discountpercent: item.discountpercent,
              Price: item.price,
              GrossValue: item.gross,
              GST: item.tax?.name || "",
              tax: item.tax?.tax || 0,
              tax_id: item.tax?.id || null,
              taxtype: item.taxtype,
              taxamount: 0,
              qitem_taxamount: item.taxamount,
              qitem_id: item.id,
              make: item.make,
              description: item.description,
              qualities:
                Array.isArray(item.qualities) && item.qualities.length > 0
                  ? item.qualities
                  : [],
              po_qty: 0,
              ApprovedQuantity: 0,
              updateGrossValue: 0,
              index: i,
              quotation_id: q.id,
              vendorId: q.vendor.id,
              Quotationcheck: false,
            };
           
          });
          
          state.CQBodyTCData[0]["Vendor" + q.vendor.id] = q.terms;
          state.CQBodyTCData[1]["Vendor" + q.vendor.id] = q.description;
          
         
          
          if (state.CQRowData && state.CQRowData.cqitems) {
            
            if (key + 1 === action.payload.length) {
              state.CQRowData.cqitems.forEach((item, index) => {
                var i = rfqItemIds.indexOf(item.rfqitem);
                if (item.cqstatus === 2) {
                  state.CQbodyData[i]["Vendor" + item.vendor.id]["id"] = item.id;
                  state.CQbodyData[i]["Vendor" + item.vendor.id][
                    "ApprovedQuantity"
                  ] = item.qty;
                  state.CQbodyData[i]["Vendor" + item.vendor.id][
                    "Quotationcheck"
                  ] = true;
                  state.CQbodyData[i]["Vendor" + item.vendor.id][
                    "updateGrossValue"
                  ] = item.gross;
                  state.CQbodyData[i]["Vendor" + item.vendor.id]["taxamount"] =
                    item.taxamount;
                  state.CQbodyData[i]["ItemName"]["totalqty"] += parseFloat(
                    parseFloat(item.qty).toFixed(3),
                  );
                } else if (item.cqstatus === 3) {
                  if (
                    !state.CQbodyData[i]["Vendor" + item.vendor.id]["old_list"]
                  ) {
                    state.CQbodyData[i]["Vendor" + item.vendor.id]["old_list"] =
                      [];
                  }
                  state.CQbodyData[i]["Vendor" + item.vendor.id]["old_list"].push(
                    {
                      id: item.id,
                      ApprovedQuantity: item.qty,
                      updateGrossValue: item.gross,
                    },
                  );

                  if (!state.CQbodyData[i]["Vendor" + item.vendor.id]["po_qty"]) {
                    state.CQbodyData[i]["Vendor" + item.vendor.id]["po_qty"] = 0;
                  }
                  state.CQbodyData[i]["Vendor" + item.vendor.id]["po_qty"] +=
                    parseFloat(parseFloat(item.qty).toFixed(3));

                  state.CQbodyData[i]["ItemName"]["totalpoqty"] += parseFloat(
                    parseFloat(item.qty).toFixed(3),
                  );
                  state.CQbodyData[i]["ItemName"]["totalpoqty"] = parseFloat(
                    parseFloat(
                      state.CQbodyData[i]["ItemName"]["totalpoqty"],
                    ).toFixed(3),
                  );
                }
              });
            }
          }
        });

        state.loading = false;
      } catch (error) {
        
        state.loading = false;
      }
      break;
    case QUOTATION_CHECKED:
      var vendorId = action.payload.vendorId;
      var index = action.payload.index;

      console.log(`🔲 [QUOTATION_CHECKED] Vendor${vendorId} index=${index} checked=${action.payload.checked}`);
      console.log(`🔲 [QUOTATION_CHECKED] BEFORE → Quotationcheck=${state.CQbodyData[index]["Vendor" + vendorId]["Quotationcheck"]}, ApprovedQuantity=${state.CQbodyData[index]["Vendor" + vendorId]["ApprovedQuantity"]}, dodelete=${state.CQbodyData[index]["Vendor" + vendorId]["dodelete"]}`);

      state.CQbodyData[index]["Vendor" + vendorId]["Quotationcheck"] =
        action.payload.checked;
      if (action.payload.checked === false) {
        state.CQbodyData[index]["ItemName"]["totalqty"] -= parseInt(
          state.CQbodyData[index]["Vendor" + vendorId]["ApprovedQuantity"],
        );
        state.CQbodyData[index]["Vendor" + vendorId]["ApprovedQuantity"] = 0;
        state.CQbodyData[index]["Vendor" + vendorId]["updateGrossValue"] = 0;
        state.CQbodyData[index]["Vendor" + vendorId]["taxamount"] = 0;

        state.CQbodyData[index]["Vendor" + vendorId]["dodelete"] = true;
      } else {
        state.CQbodyData[index]["Vendor" + vendorId]["dodelete"] = false;
      }

      console.log(`🔲 [QUOTATION_CHECKED] AFTER → Quotationcheck=${state.CQbodyData[index]["Vendor" + vendorId]["Quotationcheck"]}, ApprovedQuantity=${state.CQbodyData[index]["Vendor" + vendorId]["ApprovedQuantity"]}, dodelete=${state.CQbodyData[index]["Vendor" + vendorId]["dodelete"]}, totalqty=${state.CQbodyData[index]["ItemName"]["totalqty"]}`);

      state.newclm = "Vendor" + vendorId;
      state.newrow = index;
      break;

    case APPROVED_QUANTITY:
      var vendorId1 = action.payload.vendorId;
      var index1 = action.payload.index;

      var ApprovedQuantity =
        action.payload.ApprovedQuantity !== ""
          ? action.payload.ApprovedQuantity
          : 0;
      var gross =
        state.CQbodyData[index1]["Vendor" + vendorId1]["Price"] *
        ApprovedQuantity;
      var taxamt = 0;
      if (state.CQbodyData[index1]["Vendor" + vendorId1]["taxtype"] === 1) {
        var basicValue =
          gross /
          ((100 + state.CQbodyData[index1]["Vendor" + vendorId1]["tax"]) / 100);
        taxamt =
          (basicValue / 100) *
          state.CQbodyData[index1]["Vendor" + vendorId1]["tax"];
        var netValue = parseFloat(parseFloat(basicValue + taxamt).toFixed(3));
      } else {
        taxamt =
          (gross * state.CQbodyData[index1]["Vendor" + vendorId1]["tax"]) / 100;
        netValue = parseFloat(parseFloat(gross + taxamt).toFixed(3));
      }

      state.CQbodyData[index1]["ItemName"]["totalqty"] -= parseFloat(
        parseFloat(
          state.CQbodyData[index1]["Vendor" + vendorId1]["ApprovedQuantity"],
        ).toFixed(3),
      );
      state.CQbodyData[index1]["ItemName"]["totalqty"] = parseFloat(
        parseFloat(state.CQbodyData[index1]["ItemName"]["totalqty"]).toFixed(3),
      );

      state.CQbodyData[index1]["Vendor" + vendorId1]["ApprovedQuantity"] =
        ApprovedQuantity;
      state.CQbodyData[index1]["Vendor" + vendorId1]["updateGrossValue"] =
        netValue;
      state.CQbodyData[index1]["Vendor" + vendorId1]["taxamount"] =
        parseFloat(taxamt).toFixed(3);

      state.CQbodyData[index1]["ItemName"]["totalqty"] += parseFloat(
        parseFloat(ApprovedQuantity).toFixed(3),
      );
      state.CQbodyData[index1]["ItemName"]["totalqty"] = parseFloat(
        parseFloat(state.CQbodyData[index1]["ItemName"]["totalqty"]).toFixed(3),
      );

      state.newclm = "Vendor" + vendorId1;
      state.newrow = index1;
      break;
    case RESET_CELL_UPDATE:
      state = {
        ...state,
        newclm: initialState.newclm,
        newrow: initialState.newrow,
      };
      break;
    case COMPARE_QUOTATION_ADD:
      state = {
        ...state,
        loading: true,
      };
      break;
    case COMPARE_QOUTATION_DATA:
      state = {
        ...state,
        loading: true,
      };
      break;
    case COMPARE_QOUTATION_DATA_SUCCESS:
      state = {
        ...state,
        CQRowData: action.payload,

        loading: false,
      };
      break;
    case COMPARE_QOUTATION_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case COMPARE_QOUTATION_LIST_SUCCESS:
      var noofpages = Math.ceil(action.payload.count / state.params.page_size);
      state = {
        ...state,
        CQRowList: action.payload.results,
        CQRowListCount: action.payload.count,

        params: {
          ...state.params,
          no_of_pages: noofpages,
        },
        loading: false,
      };
      break;
    case SET_PARAMS:
      state = {
        ...state,
        params: action.payload,
      };
      break;
    case FILTER_INPUT_CHANGEVALUE:
      state = {
        ...state,
        params: {
          ...state.params,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case FILTER_SELECT_CHANGEVALUE:
      state = {
        ...state,
        filterdata: {
          ...state.filterdata,
          [action.payload.key]: action.payload.label,
        },
        params: {
          ...state.params,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case TOGGLE_ITEM_MENU:
      var CQRowList = state.CQRowList?.map((i) => {
        if (i.id === action.payload) {
          i.actionMenu = !i.actionMenu;
        } else {
          i.actionMenu = false;
        }
        return i;
      });

      state = {
        ...state,
        CQRowList: CQRowList,
      };
      break;

    case PURCHASE_ORDER_LIST:
      state = {
        ...state,
      };
      break;
    case PURCHASE_ORDER_LIST_SUCCESS:
      state = {
        ...state,
        CQPOList: action.payload,
      };
      break;
    case PURCHASE_ORDER_DATA:
      state = {
        ...state,
        POData: action.payload,
      };
      break;
    case GENERATE_PURCHASE_ORDER:
      state = {
        ...state,
      };
      break;
    case GENERATE_PURCHASE_ORDER_RESPONSE:
      var poData1 = state.POData.map((poList) => {
        if (poList.vendor_id === action.payload.data.vendor_id) {
          poList.loading = action.payload.loading;
          poList.requestStatus = action.payload.requestStatus;
        }
        return poList;
      });
      var arr1 = poData1.filter((poList) => {
        return poList.requestStatus === 2;
      });
      state = {
        ...state,
        POData: poData1,
        HideSubmiteData: arr1.length > 1,
      };
      break;
    case LIST_LAYOUT:
      state = {
        ...state,
        layout: action.payload,
        loading: false,
      };
      break;
    case FILTERS_SHOW_RIGHT_SIDEBAR:
      state = {
        ...state,
        showFilterRightSidebar: !state.showFilterRightSidebar,
      };
      break;
    case FILTERS_HIDE_RIGHT_SIDEBAR:
      state = {
        ...state,

        showFilterRightSidebar: false,
      };
      break;
    case CLEAR_FILTER:
      state = {
        ...state,
        filterdata: {},
      };
      break;
    case PO_MODEL_OPEN:
      state = {
        ...state,
        PO_Model: true,
        PO_ID: action.payload,
      };
      break;
    case PO_MODEL_CLOSE:
      state = {
        ...state,
        PO_Model: false,
        PO_index: null,
        PORowData: {},
      };
      break;
    case PO_VEND_DATA:
      state = {
        ...state,
        PO_index: action.payload.index,
        PORowData: {},
      };
      break;
    case INPUT_CHANGEVALUE:
      state = {
        ...state,
        PORowData: {
          ...state.PORowData,
          [action.payload.key]: action.payload.value,
        },
      };
      break;

    case RESET_SUBLOCATION:
      state = {
        ...state,
        PORowData: {
          ...state.PORowData,
          subLocationLabel: null,
          subLocationId: null,
        },
        sublocationslist2: { results: [] },
      };
      break;

    case PO_SELECT_CHANGEVALUE:
      state = {
        ...state,
        PORowData: {
          ...state.PORowData,
          [action.payload.key]: action.payload.label,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    default:
      state = { ...state };
      break;
  }

  return state;
};
export default CompareQuotation;
